// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ca-report-container {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
  background: #f5f5f5;
  min-height: 100vh;
}

.ca-header {
  background: white;
  padding: 30px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.ca-header h1 {
  margin: 0 0 10px 0;
  color: #2c3e50;
  font-size: 28px;
}

.ca-description {
  color: #7f8c8d;
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
}

.ca-controls {
  background: white;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  display: flex;
  gap: 20px;
  align-items: flex-end;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.control-group {
  flex: 1 1;
}

.control-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #2c3e50;
  font-size: 14px;
}

.control-group select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  background: white;
}

.control-group select:disabled {
  background: #f0f0f0;
  cursor: not-allowed;
}

.generate-button {
  padding: 10px 30px;
  background: #3498db;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.3s;
}

.generate-button:hover:not(:disabled) {
  background: #2980b9;
}

.generate-button:disabled {
  background: #bdc3c7;
  cursor: not-allowed;
}

.error-message {
  background: #fee;
  border: 1px solid #fcc;
  color: #c33;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.report-content {
  background: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.report-summary {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 20px;
  margin-bottom: 30px;
}

.summary-card {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.summary-card h3 {
  margin: 0 0 15px 0;
  color: #2c3e50;
  font-size: 18px;
}

.summary-details {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.summary-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.summary-label {
  color: #7f8c8d;
  font-weight: 500;
  font-size: 14px;
}

.summary-value {
  color: #2c3e50;
  font-weight: 600;
  font-size: 14px;
}

.summary-card.match-rate {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  text-align: center;
}

.summary-card.match-rate h3 {
  color: white;
}

.match-rate-value {
  font-size: 48px;
  font-weight: bold;
  margin: 20px 0 10px 0;
}

.match-rate-label {
  font-size: 14px;
  opacity: 0.9;
}

.connection-details-section {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border: 2px solid #3498db;
  border-radius: 8px;
  padding: 25px;
  margin-bottom: 30px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.connection-details-section h2 {
  color: #2c3e50;
  font-size: 22px;
  margin: 0 0 5px 0;
  display: flex;
  align-items: center;
}

.connection-subtitle {
  color: #5a6c7d;
  font-size: 14px;
  margin: 0 0 20px 0;
  font-style: italic;
}

.connection-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 15px;
}

.connection-item {
  display: flex;
  align-items: center;
  background: white;
  padding: 15px;
  border-radius: 6px;
  border: 1px solid #e0e4e8;
  transition: transform 0.2s, box-shadow 0.2s;
}

.connection-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.connection-icon {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  flex-shrink: 0;
}

.connection-icon i {
  color: white;
  font-size: 18px;
}

.connection-info {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-width: 0;
}

.connection-label {
  font-size: 12px;
  color: #7f8c8d;
  font-weight: 500;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.connection-value {
  font-size: 14px;
  color: #2c3e50;
  font-weight: 600;
  word-break: break-word;
}

.connection-value.success {
  color: #28a745;
  font-weight: 700;
}

.connection-value.status-badge {
  display: inline-block;
  background: #28a745;
  color: white;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  text-transform: uppercase;
}

.connection-value.monospace {
  font-family: 'Courier New', monospace;
  font-size: 13px;
  background: #f8f9fa;
  padding: 4px 8px;
  border-radius: 4px;
}

.comparison-section {
  margin-bottom: 30px;
}

.comparison-section h2 {
  color: #2c3e50;
  font-size: 20px;
  margin: 0 0 15px 0;
  padding-bottom: 10px;
  border-bottom: 2px solid #3498db;
}

.ca-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.ca-table thead {
  background: #f8f9fa;
}

.ca-table th {
  padding: 12px;
  text-align: left;
  font-weight: 600;
  color: #2c3e50;
  border-bottom: 2px solid #dee2e6;
  white-space: nowrap;
}

.ca-table td {
  padding: 12px;
  border-bottom: 1px solid #e9ecef;
}

/* Column-specific alignment */
.ca-table th.metric-name-col,
.ca-table td.metric-label {
  text-align: left;
  width: 35%;
}

.ca-table th.number-col,
.ca-table td.metric-value {
  text-align: right;
  width: 13%;
}

.ca-table th.status-col,
.ca-table td.metric-status {
  text-align: center;
  width: 13%;
}

.ca-table tbody tr:hover {
  background: #f8f9fa;
}

.ca-table tbody tr.match {
  background: #d4edda;
}

.ca-table tbody tr.match:hover {
  background: #c3e6cb;
}

.ca-table tbody tr.mismatch {
  background: #fff3cd;
}

.ca-table tbody tr.mismatch:hover {
  background: #ffe69c;
}

.ca-table td.metric-label {
  font-weight: 500;
  color: #2c3e50;
}

.ca-table td.metric-value {
  font-family: 'Courier New', monospace;
  color: #495057;
  padding-right: 20px;
}

.metric-status {
  text-align: center;
  font-weight: 600;
  font-size: 12px;
}

.status-MATCH {
  color: #28a745;
}

.status-over {
  color: #fd7e14;
}

.status-under {
  color: #dc3545;
}

.status-icon {
  display: inline-block;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  border-radius: 50%;
  margin-right: 10px;
  font-weight: bold;
  font-size: 16px;
}

.status-icon.match {
  background: #28a745;
  color: white;
}

.status-icon.over {
  background: #fd7e14;
  color: white;
}

.status-icon.under {
  background: #dc3545;
  color: white;
}

.account-status-section {
  margin-top: 30px;
}

.account-status-section h3 {
  color: #2c3e50;
  font-size: 18px;
  margin: 0 0 15px 0;
  padding-bottom: 10px;
  border-bottom: 2px solid #3498db;
}

.match-yes {
  color: #28a745;
  font-weight: 600;
  text-align: center;
}

.match-no {
  color: #dc3545;
  font-weight: 600;
  text-align: center;
}

.info-note {
  background: #e7f3ff;
  border-left: 4px solid #3498db;
  padding: 12px 15px;
  margin-top: 15px;
  font-size: 14px;
  color: #2c3e50;
  border-radius: 4px;
}

.legend {
  margin-top: 40px;
  padding-top: 20px;
  border-top: 2px solid #e9ecef;
}

.legend h3 {
  color: #2c3e50;
  font-size: 18px;
  margin: 0 0 15px 0;
}

.legend-items {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.legend-item {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #495057;
}

.legend-item .status-icon {
  margin-right: 15px;
}

/* Detailed Analysis Styles */
.detailed-analysis-row {
  background: #f8f9fa !important;
}

.detailed-analysis {
  padding: 20px;
  background: white;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  margin: 10px 0;
}

.detailed-analysis h4 {
  color: #2c3e50;
  font-size: 18px;
  margin: 0 0 20px 0;
  padding-bottom: 10px;
  border-bottom: 2px solid #3498db;
}

.difference-section {
  margin-bottom: 20px;
}

.difference-section:last-child {
  margin-bottom: 0;
}

.difference-section h5 {
  color: #2c3e50;
  font-size: 16px;
  margin: 0 0 10px 0;
  display: flex;
  align-items: center;
}

.difference-section h5 i {
  color: #e74c3c;
}

.section-description {
  color: #7f8c8d;
  font-size: 14px;
  margin: 0 0 15px 0;
  font-style: italic;
}

.difference-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  background: white;
}

.difference-table thead {
  background: #f8f9fa;
}

.difference-table th {
  padding: 10px;
  text-align: left;
  font-weight: 600;
  color: #2c3e50;
  border-bottom: 2px solid #dee2e6;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.difference-table td {
  padding: 10px;
  border-bottom: 1px solid #e9ecef;
  color: #495057;
}

.difference-table tbody tr:hover {
  background: #f8f9fa;
}

.username-col {
  font-weight: 600;
  color: #2c3e50;
  font-family: 'Courier New', monospace;
}

.status-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-badge.open {
  background: #d4edda;
  color: #155724;
}

.status-badge.locked {
  background: #fff3cd;
  color: #856404;
}

.status-badge.expired-&-locked {
  background: #f8d7da;
  color: #721c24;
}

.reason-badge {
  display: inline-block;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
}

.reason-badge.created-after {
  background: #cfe2ff;
  color: #084298;
  border: 1px solid #9ec5fe;
}

.reason-badge.excluded {
  background: #fff3cd;
  color: #856404;
  border: 1px solid #ffe69c;
}

.missing-section {
  background: #fff5f5;
  padding: 15px;
  border-radius: 6px;
  border-left: 4px solid #e74c3c;
}

.extra-section {
  background: #fff9e6;
  padding: 15px;
  border-radius: 6px;
  border-left: 4px solid #f39c12;
}

@media (max-width: 768px) {
  .report-summary {
    grid-template-columns: 1fr;
  }

  .ca-controls {
    flex-direction: column;
    align-items: stretch;
  }

  .ca-table {
    font-size: 12px;
  }

  .ca-table th,
  .ca-table td {
    padding: 8px;
  }

  .difference-table {
    font-size: 11px;
  }

  .difference-table th,
  .difference-table td {
    padding: 6px;
  }
}

/* Sample Users Section */
.sample-users-section {
  margin: 40px 0;
  padding: 30px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 2px solid #3498db;
}

.sample-users-section h2 {
  color: #2c3e50;
  font-size: 22px;
  margin: 0 0 10px 0;
  display: flex;
  align-items: center;
}

.sample-users-section .section-description {
  color: #7f8c8d;
  font-size: 14px;
  margin: 0 0 25px 0;
  font-style: italic;
}

.user-detail-card {
  background: white;
  border-radius: 8px;
  padding: 25px;
  margin-bottom: 25px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e4e8;
}

.user-detail-card:last-child {
  margin-bottom: 0;
}

.user-detail-card .user-title {
  color: #2c3e50;
  font-size: 20px;
  margin: 0 0 20px 0;
  padding-bottom: 15px;
  border-bottom: 3px solid #3498db;
  display: flex;
  align-items: center;
  gap: 10px;
}

.user-detail-card .user-title i {
  color: #3498db;
}

.privilege-comparison-grid {
  display: grid;
  gap: 20px;
}

.privilege-section {
  background: #f8f9fa;
  border-radius: 6px;
  padding: 20px;
  border: 1px solid #e0e4e8;
}

.privilege-section h4 {
  color: #2c3e50;
  font-size: 16px;
  margin: 0 0 15px 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.privilege-section h4 i {
  color: #3498db;
}

.privilege-columns {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.privilege-column {
  background: white;
  border-radius: 4px;
  padding: 15px;
  border: 1px solid #dee2e6;
}

.privilege-column .column-header {
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 2px solid #e9ecef;
  font-size: 14px;
}

.privilege-list {
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 200px;
  overflow-y: auto;
}

.privilege-list li {
  padding: 8px 12px;
  margin: 4px 0;
  background: #f8f9fa;
  border-radius: 4px;
  font-size: 13px;
  color: #495057;
  font-family: 'Courier New', monospace;
  border-left: 3px solid #3498db;
}

.privilege-list li.more-items {
  background: #e7f3ff;
  border-left-color: #3498db;
  color: #3498db;
  font-weight: 600;
  font-style: italic;
  text-align: center;
}

.privilege-list::-webkit-scrollbar {
  width: 6px;
}

.privilege-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.privilege-list::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}

.privilege-list::-webkit-scrollbar-thumb:hover {
  background: #555;
}

@media (max-width: 1024px) {
  .privilege-columns {
    grid-template-columns: 1fr;
  }

  .sample-users-section {
    padding: 20px;
  }

  .user-detail-card {
    padding: 15px;
  }
}

/* SQL Query Documentation Section */
.query-documentation-section {
  margin: 40px 0;
  padding: 30px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 2px solid #2980b9;
}

.query-documentation-section h2 {
  color: #2c3e50;
  margin: 0 0 10px 0;
  font-size: 24px;
  font-weight: 600;
}

.query-documentation-section .section-description {
  color: #7f8c8d;
  margin: 0 0 30px 0;
  line-height: 1.6;
}

.query-group {
  margin-bottom: 40px;
}

.query-group:last-child {
  margin-bottom: 0;
}

.query-group-title {
  color: #2980b9;
  font-size: 20px;
  margin: 0 0 20px 0;
  padding-bottom: 10px;
  border-bottom: 2px solid #2980b9;
  font-weight: 600;
}

.query-card {
  background: #f8f9fa;
  border-radius: 6px;
  padding: 20px;
  margin-bottom: 20px;
  border: 1px solid #dee2e6;
  transition: all 0.3s ease;
}

.query-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.query-header {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 15px;
}

.query-badge {
  background: #3498db;
  color: white;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.query-metric {
  margin: 0;
  color: #2c3e50;
  font-size: 18px;
  font-weight: 600;
}

.query-description,
.query-purpose {
  margin-bottom: 12px;
  color: #555;
  line-height: 1.6;
}

.query-description strong,
.query-purpose strong {
  color: #2c3e50;
}

.query-sql {
  margin-top: 15px;
}

.query-sql-header {
  background: #2c3e50;
  color: white;
  padding: 8px 15px;
  border-radius: 4px 4px 0 0;
  font-weight: 600;
  font-size: 14px;
}

.query-sql-code {
  background: #1e1e1e;
  color: #d4d4d4;
  padding: 15px;
  border-radius: 0 0 4px 4px;
  margin: 0;
  overflow-x: auto;
  font-family: 'Courier New', Courier, monospace;
  font-size: 13px;
  line-height: 1.6;
  border: 1px solid #2c3e50;
  border-top: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/CAReport.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA,8BAA8B;AAC9B;;EAEE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;EAEE,iBAAiB;EACjB,UAAU;AACZ;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,YAAY;EACd;AACF;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,oCAAoC;AACpC;EACE,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;EAChB,8CAA8C;EAC9C,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB","sourcesContent":[".ca-report-container {\n  padding: 20px;\n  max-width: 1400px;\n  margin: 0 auto;\n  background: #f5f5f5;\n  min-height: 100vh;\n}\n\n.ca-header {\n  background: white;\n  padding: 30px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.ca-header h1 {\n  margin: 0 0 10px 0;\n  color: #2c3e50;\n  font-size: 28px;\n}\n\n.ca-description {\n  color: #7f8c8d;\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.6;\n}\n\n.ca-controls {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  display: flex;\n  gap: 20px;\n  align-items: flex-end;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.control-group {\n  flex: 1;\n}\n\n.control-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: #2c3e50;\n  font-size: 14px;\n}\n\n.control-group select {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n  background: white;\n}\n\n.control-group select:disabled {\n  background: #f0f0f0;\n  cursor: not-allowed;\n}\n\n.generate-button {\n  padding: 10px 30px;\n  background: #3498db;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.3s;\n}\n\n.generate-button:hover:not(:disabled) {\n  background: #2980b9;\n}\n\n.generate-button:disabled {\n  background: #bdc3c7;\n  cursor: not-allowed;\n}\n\n.error-message {\n  background: #fee;\n  border: 1px solid #fcc;\n  color: #c33;\n  padding: 15px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n}\n\n.report-content {\n  background: white;\n  padding: 30px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.report-summary {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n.summary-card {\n  background: #f8f9fa;\n  padding: 20px;\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n}\n\n.summary-card h3 {\n  margin: 0 0 15px 0;\n  color: #2c3e50;\n  font-size: 18px;\n}\n\n.summary-details {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.summary-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.summary-label {\n  color: #7f8c8d;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.summary-value {\n  color: #2c3e50;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.summary-card.match-rate {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  text-align: center;\n}\n\n.summary-card.match-rate h3 {\n  color: white;\n}\n\n.match-rate-value {\n  font-size: 48px;\n  font-weight: bold;\n  margin: 20px 0 10px 0;\n}\n\n.match-rate-label {\n  font-size: 14px;\n  opacity: 0.9;\n}\n\n.connection-details-section {\n  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  border: 2px solid #3498db;\n  border-radius: 8px;\n  padding: 25px;\n  margin-bottom: 30px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.connection-details-section h2 {\n  color: #2c3e50;\n  font-size: 22px;\n  margin: 0 0 5px 0;\n  display: flex;\n  align-items: center;\n}\n\n.connection-subtitle {\n  color: #5a6c7d;\n  font-size: 14px;\n  margin: 0 0 20px 0;\n  font-style: italic;\n}\n\n.connection-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 15px;\n}\n\n.connection-item {\n  display: flex;\n  align-items: center;\n  background: white;\n  padding: 15px;\n  border-radius: 6px;\n  border: 1px solid #e0e4e8;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.connection-item:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.connection-icon {\n  width: 40px;\n  height: 40px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 15px;\n  flex-shrink: 0;\n}\n\n.connection-icon i {\n  color: white;\n  font-size: 18px;\n}\n\n.connection-info {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-width: 0;\n}\n\n.connection-label {\n  font-size: 12px;\n  color: #7f8c8d;\n  font-weight: 500;\n  margin-bottom: 4px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.connection-value {\n  font-size: 14px;\n  color: #2c3e50;\n  font-weight: 600;\n  word-break: break-word;\n}\n\n.connection-value.success {\n  color: #28a745;\n  font-weight: 700;\n}\n\n.connection-value.status-badge {\n  display: inline-block;\n  background: #28a745;\n  color: white;\n  padding: 4px 10px;\n  border-radius: 12px;\n  font-size: 12px;\n  text-transform: uppercase;\n}\n\n.connection-value.monospace {\n  font-family: 'Courier New', monospace;\n  font-size: 13px;\n  background: #f8f9fa;\n  padding: 4px 8px;\n  border-radius: 4px;\n}\n\n.comparison-section {\n  margin-bottom: 30px;\n}\n\n.comparison-section h2 {\n  color: #2c3e50;\n  font-size: 20px;\n  margin: 0 0 15px 0;\n  padding-bottom: 10px;\n  border-bottom: 2px solid #3498db;\n}\n\n.ca-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.ca-table thead {\n  background: #f8f9fa;\n}\n\n.ca-table th {\n  padding: 12px;\n  text-align: left;\n  font-weight: 600;\n  color: #2c3e50;\n  border-bottom: 2px solid #dee2e6;\n  white-space: nowrap;\n}\n\n.ca-table td {\n  padding: 12px;\n  border-bottom: 1px solid #e9ecef;\n}\n\n/* Column-specific alignment */\n.ca-table th.metric-name-col,\n.ca-table td.metric-label {\n  text-align: left;\n  width: 35%;\n}\n\n.ca-table th.number-col,\n.ca-table td.metric-value {\n  text-align: right;\n  width: 13%;\n}\n\n.ca-table th.status-col,\n.ca-table td.metric-status {\n  text-align: center;\n  width: 13%;\n}\n\n.ca-table tbody tr:hover {\n  background: #f8f9fa;\n}\n\n.ca-table tbody tr.match {\n  background: #d4edda;\n}\n\n.ca-table tbody tr.match:hover {\n  background: #c3e6cb;\n}\n\n.ca-table tbody tr.mismatch {\n  background: #fff3cd;\n}\n\n.ca-table tbody tr.mismatch:hover {\n  background: #ffe69c;\n}\n\n.ca-table td.metric-label {\n  font-weight: 500;\n  color: #2c3e50;\n}\n\n.ca-table td.metric-value {\n  font-family: 'Courier New', monospace;\n  color: #495057;\n  padding-right: 20px;\n}\n\n.metric-status {\n  text-align: center;\n  font-weight: 600;\n  font-size: 12px;\n}\n\n.status-MATCH {\n  color: #28a745;\n}\n\n.status-over {\n  color: #fd7e14;\n}\n\n.status-under {\n  color: #dc3545;\n}\n\n.status-icon {\n  display: inline-block;\n  width: 24px;\n  height: 24px;\n  line-height: 24px;\n  text-align: center;\n  border-radius: 50%;\n  margin-right: 10px;\n  font-weight: bold;\n  font-size: 16px;\n}\n\n.status-icon.match {\n  background: #28a745;\n  color: white;\n}\n\n.status-icon.over {\n  background: #fd7e14;\n  color: white;\n}\n\n.status-icon.under {\n  background: #dc3545;\n  color: white;\n}\n\n.account-status-section {\n  margin-top: 30px;\n}\n\n.account-status-section h3 {\n  color: #2c3e50;\n  font-size: 18px;\n  margin: 0 0 15px 0;\n  padding-bottom: 10px;\n  border-bottom: 2px solid #3498db;\n}\n\n.match-yes {\n  color: #28a745;\n  font-weight: 600;\n  text-align: center;\n}\n\n.match-no {\n  color: #dc3545;\n  font-weight: 600;\n  text-align: center;\n}\n\n.info-note {\n  background: #e7f3ff;\n  border-left: 4px solid #3498db;\n  padding: 12px 15px;\n  margin-top: 15px;\n  font-size: 14px;\n  color: #2c3e50;\n  border-radius: 4px;\n}\n\n.legend {\n  margin-top: 40px;\n  padding-top: 20px;\n  border-top: 2px solid #e9ecef;\n}\n\n.legend h3 {\n  color: #2c3e50;\n  font-size: 18px;\n  margin: 0 0 15px 0;\n}\n\n.legend-items {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.legend-item {\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  color: #495057;\n}\n\n.legend-item .status-icon {\n  margin-right: 15px;\n}\n\n/* Detailed Analysis Styles */\n.detailed-analysis-row {\n  background: #f8f9fa !important;\n}\n\n.detailed-analysis {\n  padding: 20px;\n  background: white;\n  border: 2px solid #e9ecef;\n  border-radius: 8px;\n  margin: 10px 0;\n}\n\n.detailed-analysis h4 {\n  color: #2c3e50;\n  font-size: 18px;\n  margin: 0 0 20px 0;\n  padding-bottom: 10px;\n  border-bottom: 2px solid #3498db;\n}\n\n.difference-section {\n  margin-bottom: 20px;\n}\n\n.difference-section:last-child {\n  margin-bottom: 0;\n}\n\n.difference-section h5 {\n  color: #2c3e50;\n  font-size: 16px;\n  margin: 0 0 10px 0;\n  display: flex;\n  align-items: center;\n}\n\n.difference-section h5 i {\n  color: #e74c3c;\n}\n\n.section-description {\n  color: #7f8c8d;\n  font-size: 14px;\n  margin: 0 0 15px 0;\n  font-style: italic;\n}\n\n.difference-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n  background: white;\n}\n\n.difference-table thead {\n  background: #f8f9fa;\n}\n\n.difference-table th {\n  padding: 10px;\n  text-align: left;\n  font-weight: 600;\n  color: #2c3e50;\n  border-bottom: 2px solid #dee2e6;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.difference-table td {\n  padding: 10px;\n  border-bottom: 1px solid #e9ecef;\n  color: #495057;\n}\n\n.difference-table tbody tr:hover {\n  background: #f8f9fa;\n}\n\n.username-col {\n  font-weight: 600;\n  color: #2c3e50;\n  font-family: 'Courier New', monospace;\n}\n\n.status-badge {\n  display: inline-block;\n  padding: 4px 10px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.status-badge.open {\n  background: #d4edda;\n  color: #155724;\n}\n\n.status-badge.locked {\n  background: #fff3cd;\n  color: #856404;\n}\n\n.status-badge.expired-&-locked {\n  background: #f8d7da;\n  color: #721c24;\n}\n\n.reason-badge {\n  display: inline-block;\n  padding: 6px 12px;\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.reason-badge.created-after {\n  background: #cfe2ff;\n  color: #084298;\n  border: 1px solid #9ec5fe;\n}\n\n.reason-badge.excluded {\n  background: #fff3cd;\n  color: #856404;\n  border: 1px solid #ffe69c;\n}\n\n.missing-section {\n  background: #fff5f5;\n  padding: 15px;\n  border-radius: 6px;\n  border-left: 4px solid #e74c3c;\n}\n\n.extra-section {\n  background: #fff9e6;\n  padding: 15px;\n  border-radius: 6px;\n  border-left: 4px solid #f39c12;\n}\n\n@media (max-width: 768px) {\n  .report-summary {\n    grid-template-columns: 1fr;\n  }\n\n  .ca-controls {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .ca-table {\n    font-size: 12px;\n  }\n\n  .ca-table th,\n  .ca-table td {\n    padding: 8px;\n  }\n\n  .difference-table {\n    font-size: 11px;\n  }\n\n  .difference-table th,\n  .difference-table td {\n    padding: 6px;\n  }\n}\n\n/* Sample Users Section */\n.sample-users-section {\n  margin: 40px 0;\n  padding: 30px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  border: 2px solid #3498db;\n}\n\n.sample-users-section h2 {\n  color: #2c3e50;\n  font-size: 22px;\n  margin: 0 0 10px 0;\n  display: flex;\n  align-items: center;\n}\n\n.sample-users-section .section-description {\n  color: #7f8c8d;\n  font-size: 14px;\n  margin: 0 0 25px 0;\n  font-style: italic;\n}\n\n.user-detail-card {\n  background: white;\n  border-radius: 8px;\n  padding: 25px;\n  margin-bottom: 25px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e0e4e8;\n}\n\n.user-detail-card:last-child {\n  margin-bottom: 0;\n}\n\n.user-detail-card .user-title {\n  color: #2c3e50;\n  font-size: 20px;\n  margin: 0 0 20px 0;\n  padding-bottom: 15px;\n  border-bottom: 3px solid #3498db;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.user-detail-card .user-title i {\n  color: #3498db;\n}\n\n.privilege-comparison-grid {\n  display: grid;\n  gap: 20px;\n}\n\n.privilege-section {\n  background: #f8f9fa;\n  border-radius: 6px;\n  padding: 20px;\n  border: 1px solid #e0e4e8;\n}\n\n.privilege-section h4 {\n  color: #2c3e50;\n  font-size: 16px;\n  margin: 0 0 15px 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.privilege-section h4 i {\n  color: #3498db;\n}\n\n.privilege-columns {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n}\n\n.privilege-column {\n  background: white;\n  border-radius: 4px;\n  padding: 15px;\n  border: 1px solid #dee2e6;\n}\n\n.privilege-column .column-header {\n  font-weight: 600;\n  color: #2c3e50;\n  margin-bottom: 12px;\n  padding-bottom: 8px;\n  border-bottom: 2px solid #e9ecef;\n  font-size: 14px;\n}\n\n.privilege-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.privilege-list li {\n  padding: 8px 12px;\n  margin: 4px 0;\n  background: #f8f9fa;\n  border-radius: 4px;\n  font-size: 13px;\n  color: #495057;\n  font-family: 'Courier New', monospace;\n  border-left: 3px solid #3498db;\n}\n\n.privilege-list li.more-items {\n  background: #e7f3ff;\n  border-left-color: #3498db;\n  color: #3498db;\n  font-weight: 600;\n  font-style: italic;\n  text-align: center;\n}\n\n.privilege-list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.privilege-list::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 3px;\n}\n\n.privilege-list::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 3px;\n}\n\n.privilege-list::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n@media (max-width: 1024px) {\n  .privilege-columns {\n    grid-template-columns: 1fr;\n  }\n\n  .sample-users-section {\n    padding: 20px;\n  }\n\n  .user-detail-card {\n    padding: 15px;\n  }\n}\n\n/* SQL Query Documentation Section */\n.query-documentation-section {\n  margin: 40px 0;\n  padding: 30px;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  border: 2px solid #2980b9;\n}\n\n.query-documentation-section h2 {\n  color: #2c3e50;\n  margin: 0 0 10px 0;\n  font-size: 24px;\n  font-weight: 600;\n}\n\n.query-documentation-section .section-description {\n  color: #7f8c8d;\n  margin: 0 0 30px 0;\n  line-height: 1.6;\n}\n\n.query-group {\n  margin-bottom: 40px;\n}\n\n.query-group:last-child {\n  margin-bottom: 0;\n}\n\n.query-group-title {\n  color: #2980b9;\n  font-size: 20px;\n  margin: 0 0 20px 0;\n  padding-bottom: 10px;\n  border-bottom: 2px solid #2980b9;\n  font-weight: 600;\n}\n\n.query-card {\n  background: #f8f9fa;\n  border-radius: 6px;\n  padding: 20px;\n  margin-bottom: 20px;\n  border: 1px solid #dee2e6;\n  transition: all 0.3s ease;\n}\n\n.query-card:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  transform: translateY(-2px);\n}\n\n.query-header {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  margin-bottom: 15px;\n}\n\n.query-badge {\n  background: #3498db;\n  color: white;\n  padding: 4px 12px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.query-metric {\n  margin: 0;\n  color: #2c3e50;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.query-description,\n.query-purpose {\n  margin-bottom: 12px;\n  color: #555;\n  line-height: 1.6;\n}\n\n.query-description strong,\n.query-purpose strong {\n  color: #2c3e50;\n}\n\n.query-sql {\n  margin-top: 15px;\n}\n\n.query-sql-header {\n  background: #2c3e50;\n  color: white;\n  padding: 8px 15px;\n  border-radius: 4px 4px 0 0;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.query-sql-code {\n  background: #1e1e1e;\n  color: #d4d4d4;\n  padding: 15px;\n  border-radius: 0 0 4px 4px;\n  margin: 0;\n  overflow-x: auto;\n  font-family: 'Courier New', Courier, monospace;\n  font-size: 13px;\n  line-height: 1.6;\n  border: 1px solid #2c3e50;\n  border-top: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
